import React from 'react'

const BenefitItem = ({title, description, icon}) => {
    return (
        <div className="front-home-page-benefit">
            {/*<img src={icon} alt={title}/>*/}
            <div style={{backgroundImage: `url(${icon})`, width: '200px', height: '200px', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'contain'}}></div>
            <h2 className="red-title-2">{title}</h2>
            <p className="red-primary-text">{description}</p>
        </div>
    )
}

export default BenefitItem